export enum ProfitType {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  ALL_TIME = 'ALL_TIME',
}
